export enum ReferenceType {
  TALKING_FACE = 'Talking Face',
  AI_MEDIA = 'AI Media',
  CAPTIONS = 'Captions',
  UPLOADS = 'Uploads',
  CUSTOM = 'Custom'
}

export enum ResolutionEnum {
  LD_240P = '240p',
  SD_360P = '360p', 
  SD_480P = '480p',
  HD_720P = '720p',
  FULL_HD_1080P = '1080p',
  QHD_1440P = '1440p',
  UHD_4K = '2160p',
}

export enum UpscaleModelType {
  TOPAZ = 'topaz'
}

export enum AiClipperModelType {
  AICLIPPER = 'AI Clipper',
}